import React, { useState }from 'react'
import { Img, DivTextSlider, TitleText, SubText } from './styles';

import { Carousel } from 'antd';
import image1_big from '../../images/imagen1_big.png'
import image1_medium from '../../images/imagen1_medium.png'
import image1_small from '../../images/imagen1_small.png'

import image2_big from '../../images/imagen2_big.png'
import image2_medium from '../../images/imagen2_medium.png'
import image2_small from '../../images/imagen2_small.png'

import image3_big from '../../images/imagen3_big.png'
import image3_medium from '../../images/imagen3_medium.png'
import image3_small from '../../images/imagen3_small.png'




export const SliderCarousel = () => {

    const onChangeBefore = () =>  {
        setHide(true);
    }

    const onChangeAfter = () =>  {
        setHide(false);
    }

    const [isHide, setHide] = useState(false);

    var settings = {
        autoplay: true,
        autoplaySpeed: 3000,
        effect: 'fade',
    }

    return (
        <Carousel beforeChange={onChangeBefore} afterChange={onChangeAfter} {...settings}>
            <div>
                <Img img={image1_medium} imgSmall={image1_small} imgBig={image1_big}/>
                <DivTextSlider isHide={isHide}>
                    <TitleText>
                        PRODUCTOS EXCLUSIVOS
                    </TitleText>
                    <SubText>Revisa nuestro catálogo</SubText>
                </DivTextSlider>
            </div>
            <div>
                <Img img={image2_medium} imgSmall={image2_small} imgBig={image2_big}/>
                <DivTextSlider isHide={isHide}>
                    <TitleText>
                        LOS MEJORES COMPONENTES NATURALES
                    </TitleText>
                    <TitleText isHide={isHide}>
                        
                    </TitleText>
                    <SubText>Para una mejor cuidado de la piel y cabello</SubText>
                </DivTextSlider>
            </div>
            <div>
                <Img img={image3_medium} imgSmall={image3_small} imgBig={image3_big}/>
                <DivTextSlider isHide={isHide}>
                    <TitleText>
                        PROMO PACK
                    </TitleText>
                    <SubText>Llevate nuestros 3 productos por un incrible precio</SubText>
                </DivTextSlider>
            </div>
        </Carousel>
    )
}